<script setup lang="ts">
import { DropdownMenuItem, type DropdownMenuItemProps as BaseDropdownMenuItemProperties, useForwardProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'
import { ListItem, type ListItemInterface } from '../list'

interface DropdownMenuItemProperties extends BaseDropdownMenuItemProperties {
  class?: HTMLAttributes['class']
  inset?: boolean
  item: ListItemInterface
}

const properties = defineProps<DropdownMenuItemProperties>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = properties

  return delegated
})

const forwardedProperties = useForwardProps(delegatedProperties)
</script>

<template>
  <DropdownMenuItem v-bind="forwardedProperties" :class="cn('atabix-dropdown-menu__item')">
    <ListItem :item="item" />
  </DropdownMenuItem>
</template>

<style lang="scss">
.atabix-dropdown-menu__item {
  @apply relative;
  @apply flex;
  @apply items-center;
  @apply cursor-default;
  @apply select-none;
  @apply rounded-sm;
  @apply text-base;
  @apply outline-none;
  @apply transition-colors;
  @apply focus:bg-background-hover;
  @apply focus:text-form-foreground-label;
  @apply data-[disabled]:pointer-events-none;
  @apply data-[disabled]:opacity-50;

  .atabix-list-item {
    @apply p-0;
  }
}
</style>
